import React, { Component } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import SpotFormButtons from "./spot-form-buttons";
import spotFormValidation from "./spot-form-validation";
import ajax from "../util/util-ajax";
import util from "../util/util";
import Dropzone from "react-dropzone";
import Tooltip from "../tooltip/tooltip";

const jQuery = window.jQuery;

// use the same logic to set state (on load, on prop change);
const returnInitialState = (props = {}) => ({
  errors: {}, // prop names determine which errors to show;
  id: props.params ? Number(props.params.id) : 0, // id of the rule we are editing (0 means new rule to create);
  loaded: false, // have the Ajax calls resolved, and we're ready to show the form;
  showProgressBar: false, // hide/show file upload progress bar;
  statusMessage: ""
});

export default class SpotForm extends Component {
  constructor(props) {
    super(props);

    this.state = returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;
    this.getSpot();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState(returnInitialState(nextProps), this.getSpot);
  }

  render() {
    if (this.state.loaded === false) {
      return <LoadingIndicatorHeader />;
    } else {
      const displayErrors = util.formatVideoError(this.state.statusMessage);
      return (
        <form className="spot-form" encType="multipart/form-data" action="#">
          <div className="row">
            <div className="col-sm-6">
              <h4 className="page__title">
                {this.state.id === 0 ? `New Spot` : `Edit Spot`}
              </h4>
            </div>
            <div className="col-sm-6 hidden-xs">
              <SpotFormButtons
                onCancel={() => this.onCancel()}
                onSubmit={() => this.onSubmit()}
              />
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-sm-12">
              <div
                className={
                  this.state.errors.name ? `form-group has-error` : `form-group`
                }
              >
                <label className="control-label" htmlFor="name">
                  Spot Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  value={this.state.name}
                  autoFocus
                  onChange={e => this.setState({ name: e.target.value })}
                  maxLength="100"
                  readOnly={this.state.failed}
                />
                <p className={this.state.errors.name ? `help-block` : `hidden`}>
                  {this.state.errors.name}
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label className="control-label">Source</label>
                <div className="radio">
                  <label className="radio-inline">
                    <input
                      type="radio"
                      name="source"
                      value="1"
                      checked={this.state.sourceType === 1}
                      onChange={e => {
                        this.setState({
                          sourceType: Number(e.target.value)
                        });
                      }}
                    />{" "}
                    URL
                  </label>
                  <label className="radio-inline">
                    <input
                      type="radio"
                      name="source"
                      value="2"
                      checked={this.state.sourceType === 2}
                      onChange={e => {
                        this.setState({
                          sourceType: Number(e.target.value)
                        });
                      }}
                    />{" "}
                    File
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-8">
              <div
                id="spot-form__url"
                className={this.state.sourceType === 1 ? `` : `hidden`}
              >
                <div
                  className={
                    this.state.errors.sourceUrl
                      ? `form-group has-error`
                      : `form-group`
                  }
                >
                  <label className="control-label" htmlFor="url">
                    URL
                  </label>
                  <input
                    type="text"
                    id="url"
                    className="form-control"
                    value={this.state.sourceUrl ? this.state.sourceUrl : ``}
                    maxLength="200"
                    onChange={e => this.setState({ sourceUrl: e.target.value })}
                  />
                  <p
                    className={
                      this.state.errors.sourceUrl ? `help-block` : `hidden`
                    }
                  >
                    A valid URL is required. Maximum of 200 characters.
                  </p>
                </div>
              </div>

              <div
                id="spot-form__file"
                className={this.state.sourceType === 2 ? `` : `hidden`}
              >
                <div
                  className={
                    this.state.errors.sourceFile
                      ? `form-group has-error`
                      : `form-group`
                  }
                >
                  <label className="control-label">File</label>
                  {this.state.sourceFile !== util.spotFormDefaultSourceFile && (
                    <span>
                      &nbsp;(
                      <button
                        type="button"
                        className="btn btn-link button_as_link"
                        onClick={() => {
                          this.setState({
                            sourceFile: util.spotFormDefaultSourceFile
                          });
                        }}
                      >
                        Replace file
                      </button>
                      )
                    </span>
                  )}
                  <div className="spot-form__file">
                    {this.state.sourceType === 2 &&
                    this.state.sourceFile === util.spotFormDefaultSourceFile ? (
                      <Dropzone
                        className="form-control spot-form__file-dropzone"
                        activeClassName="spot-form__file-dropzone--active"
                        onDrop={(acceptedFiles, rejectedFiles) =>
                          this.onDrop(acceptedFiles, rejectedFiles)
                        }
                        multiple={false}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.sourceFile
                          }}
                        />
                      </Dropzone>
                    ) : (
                      <div
                        className="form-control spot-form__file-dropzone"
                        dangerouslySetInnerHTML={{
                          __html: this.state.sourceFile
                        }}
                      />
                    )}

                    {this.state.showProgressBar ? (
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-striped active"
                          role="progressbar"
                          aria-valuenow={this.state.progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: `${this.state.progress}%` }}
                        >
                          {this.state.progress}% Complete
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <p
                    className={
                      this.state.errors.sourceFile ? `help-block` : `hidden`
                    }
                  >
                    {this.state.errors.uploading ? (
                      <span>File is still uploading.</span>
                    ) : (
                      <span>
                        File is required, and must be less than{" "}
                        {util.spotFormMaxFilesize / 1024}GB.
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
            {displayErrors.length ? (
              <div className="col-xs-12">
                <div className="page__status-message">
                  <ul>
                    {displayErrors.map((errorMessage, i) => (
                      <li key={errorMessage}>{errorMessage}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <div className="well">
                  <div className="form-group">
                    {
                      <div>
                        <div className="row">
                          <div className="col-xs-4">
                            <div
                              className={
                                this.state.errors["id"]
                                  ? `form-group has-error`
                                  : `form-group`
                              }
                            >
                              <label className="control-label" htmlFor={`id`}>
                                Element ID
                              </label>
                              <div>
                                <input
                                  type="text"
                                  id="spot-element-id"
                                  className="form-control"
                                  value={this.state.element_id}
                                  onChange={e =>
                                    this.setState({
                                      element_id: e.target.value
                                    })
                                  }
                                  maxLength="100"
                                  readOnly={this.state.failed}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xs-2">
                            <label
                              className={`control-label`}
                              htmlFor={`protrack_id`}
                            >
                              Protrack ID
                            </label>
                            <input
                              type="text"
                              id="protrack_id"
                              className="form-control"
                              value={this.state.protrack_id}
                              maxLength="100"
                              onChange={e =>
                                this.setState({ protrack_id: e.target.value })
                              }
                              readOnly={this.state.failed}
                            />
                          </div>
                          <div className="col-md-3 col-xs-4">
                            <label htmlFor={`client_name`}>Client Name</label>
                            <input
                              type="text"
                              id="client_name"
                              className="form-control"
                              value={this.state.client_name}
                              maxLength="255"
                              onChange={e =>
                                this.setState({ client_name: e.target.value })
                              }
                              readOnly={this.state.failed}
                            />
                          </div>

                          <div className="col-md-2 col-xs-4">
                            <label className="control-label" htmlFor="tape">
                              Tape
                            </label>
                            <input
                              type="text"
                              id="tape"
                              className="form-control"
                              value={this.state.tape}
                              maxLength="255"
                              onChange={e =>
                                this.setState({ tape: e.target.value })
                              }
                              readOnly={this.state.failed}
                            />
                          </div>

                          <div className="col-md-1 col-xs-4">
                            <label className="control-label" htmlFor="duration">
                              Duration
                            </label>
                            <input
                              type="text"
                              id="duration"
                              className="form-control"
                              value={this.state.duration}
                              maxLength="255"
                              data-tip="Completed automatically after spot ingestion."
                              data-for="spotFormDuration"
                              readOnly={true}
                            />
                            <Tooltip id="spotFormDuration" />
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <hr className="visible-xs-block" />
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label
                  className="control-label control-label--optional"
                  htmlFor="description"
                >
                  Description
                </label>
                <textarea
                  id="description"
                  className="form-control"
                  value={this.state.description}
                  rows="3"
                  onChange={e => this.setState({ description: e.target.value })}
                  readOnly={this.state.failed}
                >
                  {this.state.description}
                </textarea>
              </div>
            </div>
          </div>

          <hr />

          <SpotFormButtons
            onCancel={() => this.onCancel()}
            onSubmit={() => this.onSubmit()}
          />
        </form>
      );
    }
  }

  onDrop(acceptedFiles) {
    const file = acceptedFiles[0];

    if (file) {
      const fileName = file.name;
      const fileSize = Math.ceil(file.size / (1024 * 1024)); // convert bytes into megabytes;
      let fileType = file.type;

      // see if there are any errors before proceeding;
      const validationResult = spotFormValidation({ filesize: fileSize });

      // danger will robinson, we have a file size error;
      if (validationResult.hasErrors) {
        // display the error(s) - existing and new;
        // and remove any previous value for the file upload;
        this.setState(
          {
            errors: _.merge({}, this.state.errors, validationResult.errors),
            sourceFile: util.spotFormDefaultSourceFile
          },
          util.putFoucsOnError
        );

        // stop any further processing;
        return false;
      }

      // it seems that 'react-dropzone' on Windows doesn't recognise the .mxf file type
      // so trying to take the file type from the file name, in case it's not recognised
      if (!fileType) {
        fileType = fileName.split(`.`).pop();
      }

      const report = {
        filename: fileName,
        filetype: fileType,
        new_bucket: true
      };

      // sourceFile isn't known yet, it will be determined in the response from the Django server;
      let sourceFile = ``;

      // get the data needed to post to S3;
      util
        .getS3Url(report)
        .then(data => {
          const s3Report = new FormData();
          const s3Url = data.data.url;

          // take whatever was returned from Django;
          // and include it in the post to S3;
          for (const key in data.data.fields) {
            s3Report.append(key, data.data.fields[key]);
          }

          sourceFile = data.url;

          // also include the file;
          s3Report.append(`file`, file);

          // add a progress callback;
          const progressCallback = () => {
            const xhr = new window.XMLHttpRequest();

            xhr.upload.addEventListener(
              `progress`,
              progressEvent => {
                if (progressEvent.lengthComputable) {
                  const percentComplete = Math.ceil(
                    (progressEvent.loaded / progressEvent.total) * 100
                  );

                  // update the progress indicator;
                  this.mounted &&
                    this.setState({
                      progress: percentComplete
                    });
                }
              },
              false
            );

            return xhr;
          };

          // turn on the progress indicator;
          this.mounted &&
            this.setState({
              progress: 0,
              showProgressBar: true
            });
          // start the file upload;
          return util
            .saveFileToS3(s3Report, s3Url, progressCallback)
            .fail(() => {
              this.mounted &&
                this.setState({
                  showProgressBar: false,
                  sourceFile: util.spotFormDefaultSourceFile
                });
            });
        })
        .then(() => {
          // let the user read the completed message for this long;
          const timeToShowCompletedUpload = 1500;

          setTimeout(() => {
            // take the existing errors and remove the file error;
            // the file just finished uploading, there aren't anymore file errors;
            const errors = _.merge(
              {},
              this.state.errors,
              validationResult.errors
            );

            delete errors.sourceFile;

            // then turn off the progress indicator and set the filename to display;
            this.mounted &&
              this.setState(
                {
                  errors: errors,
                  showProgressBar: false,
                  sourceFile: sourceFile
                },
                util.putFoucsOnError
              );
          }, timeToShowCompletedUpload);
        });
    }
  }

  // submit the form;
  onSubmit() {
    // build the object to send to the server;
    const report = {
      id: this.state.id,
      description: this.state.description.trim(),
      name: this.state.name.trim(),
      showProgressBar: this.state.showProgressBar, // used by validation only;
      source: this.state.sourceType,
      source_file: this.state.sourceType === 2 ? this.state.sourceFile : null,
      source_url: this.state.sourceType === 1 ? this.state.sourceUrl : null,
      sourceFile: this.state.sourceType === 2 ? this.state.sourceFile : null, // used by validation only;
      sourceUrl: this.state.sourceType === 1 ? this.state.sourceUrl : null, // used by validation only;
      element_id: this.state.element_id.trim(),
      client_name: this.state.client_name.trim(),
      protrack_id: this.state.protrack_id.trim(),
      tape: this.state.tape.trim()
    };

    // see if there are any errors before proceeding;
    const validationResult = spotFormValidation(report);

    // danger will robinson, we have errors;
    if (validationResult.hasErrors) {
      this.setState(
        {
          errors: validationResult.errors
        },
        util.putFoucsOnError
      );

      // stop any further processing;
      return false;

      // good to go, clear any existing errors;
    } else {
      this.setState({
        errors: {}
      });
    }

    // put the button into a processing state;
    const $button = jQuery(`.btn-primary`).button(`loading`);

    // save the form data;
    util
      .saveSpot(report.id, report)
      // if there is a backend error (validation,...) on Spot save
      .fail(error => {
        const serializerNameExistsError =
          "A Spot with this name already exists.";
        const api_error = _.get(error, "responseJSON.Validation_Error[0]");

        // if the name already exists
        if (serializerNameExistsError === api_error) {
          this.setState(
            {
              errors: _.merge({}, this.state.errors, { name: api_error })
            },
            util.putFoucsOnError
          );
          // if there is a different backend (4xx, 5xx) error
        } else {
          ajax.onFail(error);
        }

        setTimeout(() => {
          // reset the button on fail so it can be clicked again;
          $button.button(`reset`);
        }, util.delayForm);

        // stop any further processing, as the Pod was not saved in the DB
        return false;
      })
      .then(data => {
        const $spotId = data.id;
        setTimeout(() => {
          const newUrl = util.returnSpotDetailUrl($spotId);
          // load the detail page;
          browserHistory.push(newUrl);
        }, util.delayForm);
      });
  }

  // cancel this action (do nothing and go somewhere else);
  onCancel() {
    const newUrl =
      this.state.id === 0
        ? util.returnSpotListUrl()
        : util.returnSpotDetailUrl(this.state.id);

    browserHistory.push(newUrl);
  }

  // get spot data to display;
  getSpot() {
    if (this.state.id === 0) {
      this.mounted &&
        this.setState({
          statusMessage: ``,
          description: ``,
          failed: false,
          loaded: true,
          name: ``,
          ready: false,
          sourceType: 1,
          sourceFile: util.spotFormDefaultSourceFile,
          sourceUrl: ``,
          element_id: ``,
          client_name: ``,
          protrack_id: ``,
          tape: ``,
          duration: ``
        });
    } else {
      util.getSpot(this.state.id).then(data => {
        const source = Number(data.source);

        setTimeout(() => {
          this.mounted &&
            this.setState({
              description: data.description,
              failed: data.aws_status === 3,
              loaded: true,
              name: data.name,
              ready: data.aws_status === 2,
              sourceType: source,
              sourceFile: data.source_file
                ? data.source_file
                : util.spotFormDefaultSourceFile,
              sourceUrl: data.source_url,
              statusMessage: data.aws_status_message,
              element_id: data.element_id,
              client_name: data.client_name,
              protrack_id: data.protrack_id,
              tape: data.tape,
              duration:
                typeof data.duration === "number"
                  ? (data.duration / 1000).toFixed(2)
                  : "N/A"
            });
        }, util.delayDetail);
      });
    }
  }
}

SpotForm.propTypes = {
  params: PropTypes.object
};
